/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * EntityState:<br />
 * Inactive - unavailable for sale<br />
 * Active - available for sale
 * @export
 */
export const TravelineEntityStateDto = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type TravelineEntityStateDto = typeof TravelineEntityStateDto[keyof typeof TravelineEntityStateDto];


export function instanceOfTravelineEntityStateDto(value: any): boolean {
    for (const key in TravelineEntityStateDto) {
        if (Object.prototype.hasOwnProperty.call(TravelineEntityStateDto, key)) {
            if (TravelineEntityStateDto[key as keyof typeof TravelineEntityStateDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TravelineEntityStateDtoFromJSON(json: any): TravelineEntityStateDto {
    return TravelineEntityStateDtoFromJSONTyped(json, false);
}

export function TravelineEntityStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineEntityStateDto {
    return json as TravelineEntityStateDto;
}

export function TravelineEntityStateDtoToJSON(value?: TravelineEntityStateDto | null): any {
    return value as any;
}

export function TravelineEntityStateDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): TravelineEntityStateDto {
    return value as TravelineEntityStateDto;
}

